import clsx from 'clsx';
import MapPin from 'Components/Map/MapPin';
import { Drop } from 'grommet';
import { memo } from 'preact/compat';
import { useRef, useState } from 'preact/hooks';

import HabitatCard from '@/components/HabitatCard';

import { useWindowResize } from '../../../hooks';
import { onLinkButtonClick } from '../helpers';
import style from './style.scss';

const DesktopMap = ({ habitats, urlParams, onShowTrailer }) => {
  const [isMapImageLoaded, setIsMapImageLoaded] = useState(false);
  const mapRef = useRef(null);
  const pinRefs = useRef({});
  const [activeHabitat, setActiveHabitat] = useState();
  const { width: windowWidth } = useWindowResize();

  const mapClickHandler = (id) => {
    setActiveHabitat(habitats.find(({ _id }) => id === _id));
  };

  const onClose = () => {
    setActiveHabitat();
  };

  return (
    <div className={style.desktopMap}>
      <div className={style.content}>
        <div className={style.map} onClick={mapClickHandler} ref={mapRef}>
          <div className={style.wrapper}>
            {isMapImageLoaded &&
              habitats.map((habitat) => (
                <MapPin
                  pinRefs={pinRefs}
                  key={habitat._id}
                  habitat={habitat}
                  activeHabitatId={activeHabitat?._id}
                  smallPin={windowWidth < 768}
                  isFree={urlParams.freeHabitat && habitat._id === urlParams.freeHabitat}
                  onClick={mapClickHandler}
                  delay={Math.floor(Math.random() * 400)}
                />
              ))}

            <img
              onLoad={() => setIsMapImageLoaded(true)}
              className={style.image}
              src="https://zoolife.tv/assets/zoolifeMap4.webp"
              alt="map-bg"
            />
          </div>
        </div>

        {activeHabitat && pinRefs.current[activeHabitat._id] && (
          <Drop
            align={{ top: 'top', bottom: 'bottom' }}
            target={pinRefs.current[activeHabitat._id]}
            onClickOutside={onClose}
            background="transparent"
          >
            <div className={clsx(style.description, style.habitatSelected)}>
              <div>
                <HabitatCard
                  className={style.card}
                  slug={activeHabitat.slug}
                  zooSlug={activeHabitat.zoo?.slug}
                  online={activeHabitat.online}
                  liveTalk={activeHabitat.liveTalk}
                  title={activeHabitat.title}
                  image={activeHabitat.wideImage}
                  logo={activeHabitat.zoo?.logo}
                  habitatId={activeHabitat._id}
                  trailer={activeHabitat.trailer}
                  onShowTrailer={onShowTrailer}
                  description={activeHabitat.description}
                  primaryButtonTitle="Visit"
                  onClickPrimaryButton={onLinkButtonClick(urlParams, activeHabitat)}
                  onClose={onClose}
                />
              </div>
            </div>
          </Drop>
        )}
      </div>
    </div>
  );
};
export default memo(DesktopMap);
